export enum AutobookProfileType {
  SLOT = "SLOT",
  FLOAT_JOB_WINDOW = "FLOAT_JOB_WINDOW",
  FLOAT_PROFILE_WINDOW = "FLOAT_PROFILE_WINDOW"
}
